module.exports = __webpack_public_path__ + "img/industry.0a789bdc.jpg";